import React, { FormEvent, useCallback, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import "./PopUpInfo.css";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from "../../../../redux/reducers/root";
import AmpLoadingSpinner from "../../../common/AmpLoadingSpinner/AmpLoadingSpinner";
import { getPOIList, getSnapShot, getSnapshotWithCaptcha, resetgetSnapShot } from "../../../../redux/actions/nbhd/nbhd";
import { getSnapShotState } from "../../../../redux/reducers/getSnapshotInfoReducer/getSnapshotInfoReducer";
import PopUpHeart from "../PopUpHeart/PopUpHeart";
import GetStreetView from "../GetStreetView/GetStreetView";
import { changeIsCloseable, changeModalContent, changeModalState } from "../../../../redux/actions/modal/modal";
import AmpCaptcha from "../../../common/AmpCaptcha/AmpCaptcha";
import AmpButton from "../../../common/AmpButton/AmpButton";
import extractFormData from "../../../../utils/extractFormData";
import { setToastNotification } from "../../../../redux/actions/toastNotification/toastNotification";
import { isAmppa } from "../../../../utils/isAmppa";

interface SnapData {
    roll: string;
    type: "POI" | "SNAPSHOT" | "MY_PROPERTY";
    centroid: {
        lat: number;
        lng: number
    }

}

interface PopUpInfoProps {
    coords: Array<number>;
    snapRoll: string
    snapList: Array<SnapData>;
}

export default function PopUpInfo(props: PopUpInfoProps) {

    // // TODO Change this so that the pop up doesn't also handle creating snapshots
    // const RollNumber = useSelector((state: RootState) => state.RollNumberReducer.RollNumber as getRollNumberState);
    // -------------------------------------------------------------------!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const snapShotInfo = useSelector((state: RootState) => state.SnapShotReducer.snapShotInfo as getSnapShotState);

    const { t } = useTranslation(["nbhd", "login"]);

    const dispatch = useDispatch();

    // const rollNum: string = RollNumber["rollNumDetail"]?.['roll'];

    // const newLat: string = RollNumber["rollNumDetail"]?.['lat'];

    // const newLng: string = RollNumber["rollNumDetail"]?.['lng'];

    const loading: boolean = snapShotInfo["loading"];

    const userProfileId = window.localStorage.getItem("userProfileId");

    const snapShotInfoData = snapShotInfo["snapShotInfo"]?.['data'];

    const currentProp = useSelector((state: RootState) => state.propertyListReducer.currentProperty);

    const currentRoll = currentProp["currentProperty"];
    const ownerType = currentProp["currentOwnerType"];
    const [previousSnap, setPreviousSnap] = useState<Record<string, unknown>>();

    const [showCaptchaModel, setCaptcha] = useState(false);

    const captchaComplete = useCallback((e: FormEvent) => {
        e.preventDefault();
        dispatch(changeModalState("modal-fade-out"));
        dispatch(changeIsCloseable(false));
        const data = extractFormData(e);
        const captcha = data["g-recaptcha-response"]
        if (userProfileId !== null && currentRoll !== null && props.snapRoll !== "" && captcha) {
            props.snapRoll && dispatch(getSnapshotWithCaptcha(userProfileId, currentRoll, props.snapRoll, ownerType, captcha));
        }
    }, [currentRoll, dispatch, ownerType, props.snapRoll, userProfileId])

    useEffect(() => {
        if(snapShotInfo["snapShotInfo"]?.['message'] ===  "Not a Snapable property") {
            if(props.snapRoll) {
                dispatch(setToastNotification(t('nbhd.popup-card.not-snappable', { roll: props.snapRoll}), "warning"));
            }
        }

        if(snapShotInfo["snapShotInfo"]?.['message'] === "No Data") {
            if(props.snapRoll) {
                dispatch(setToastNotification(t('nbhd.popup-card.no-data', { roll: props.snapRoll}), "warning"));
            }
        }

        if(snapShotInfo["snapShotInfo"]?.['message'] === "Max Snaps") {
            if(props.snapRoll) {
                dispatch(setToastNotification(t('nbhd.popup-card.no-add'), "warning"));
            }
        }
    // eslint-disable-next-line
    }, [snapShotInfo])

    useEffect(() => {
        
        if (props.snapRoll) {

            const snapListFix = props.snapList ? props.snapList : [];

            // Make sure there is a 19 digit varient of the roll number to compare against the snapList
            const snapRollNormalized = props.snapRoll + (props.snapRoll.length === 15 ? "0000" : "")
            const snapRolls =  snapListFix.map((value: SnapData) => {
                return value["roll"]
            });

            // 25 
            if (snapListFix.length === 26 ) {
                dispatch(setToastNotification(t('nbhd.popup-card.warn-snaps', { num: 25, remnum: 75}), "warning"));
            // 75
            } else if(snapListFix.length === 76 ) {
                dispatch(setToastNotification(t('nbhd.popup-card.warn-snaps', { num: 75, remnum: 25}), "warning"));
            // 100
            } else if (snapListFix.length === 101) {
                dispatch(setToastNotification(t('nbhd.popup-card.max-snaps'), "warning"));
                // Reset toast notif after 2 seconds
                setTimeout(() => {
                    dispatch(setToastNotification("", "warning"))
                }, 1500)
            }

            // 50 snapshots + subject property = 51
            if (userProfileId !== null && currentRoll !== null && props.snapRoll !== "" && (snapListFix.length !== 51 || snapRolls.includes(snapRollNormalized))) {
                dispatch(resetgetSnapShot)
                props.snapRoll && dispatch(getSnapShot(userProfileId, currentRoll, props.snapRoll, ownerType));
            } else if (snapListFix.length === 51 && !snapRolls.includes(snapRollNormalized) && props.snapRoll !== "") {
                setCaptcha(true);
            }
        }

        // only want this effect to run when the snap roll changes not the list
        // eslint-disable-next-line
    }, [props.snapRoll, currentRoll, dispatch, ownerType, userProfileId]);

    useEffect(() => {

        if(showCaptchaModel){
            dispatch(changeModalState("modal-fade-in"));
            dispatch(changeIsCloseable(false));
            dispatch(changeModalContent(<>
                <form className="captcha-form" onSubmit={(e) => captchaComplete(e)}>
                    <p>{t("nbhd.popup-card.captcha-content")}</p>
                    <AmpCaptcha/>
                    <div className="captcha-form-bottom-row">
                        <AmpButton 
                            onClick={ (e) => {return null} } type={"submit"} text={t("submit", {ns: "login"})}
                        />
                    </div>
 
                </form>
            </>, t("nbhd.popup-card.catpcha-title")))
        }
    }, [showCaptchaModel, captchaComplete, dispatch, t])


    useEffect(() => {
        const snap = snapShotInfo["snapShotInfo"]
        if (previousSnap !== snap) {
            // If the new tag is present we assume we just added this snapshot and need to update the list
            if (snap?.["new"] === true && userProfileId !== null) {
                dispatch(getPOIList(userProfileId, currentRoll, ownerType));

            }
            setPreviousSnap(snap);
        }

    }, [snapShotInfo, previousSnap, currentRoll, dispatch, ownerType, userProfileId])

    if (!snapShotInfoData || loading || props.snapRoll === "") {
        return <>
            <GetStreetView coords={props.coords} address={''} />
            <AmpLoadingSpinner loading={loading}>
                <table className="table table-sm popup-address" role="presentation">
                    <tbody>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.Address")}</b>
                            </td>
                            <td>
                                N/A
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.Property-Description")}</b>
                            </td>
                            <td>
                                N/A
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.Year-Built")}</b>
                            </td>
                            <td>
                                N/A
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.Building")}</b>
                            </td>
                            <td>
                                N/A
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.Lot-Size")}</b>
                            </td>
                            <td>
                                N/A
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.Number-of-Storeys")}</b>
                            </td>
                            <td>
                                N/A
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.CVA")}</b>
                            </td>
                            <td>
                                N/A
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.Sales")}</b>
                            </td>
                            <td>
                                N/A
                            </td>
                        </tr>
                        {isAmppa && (<tr>
                            <td>
                                <b>{t("nbhd.popup-card.roll-num")}</b>
                            </td>
                            <td>
                                N/A
                            </td>
                        </tr>)}
                    </tbody>
                </table>
            </AmpLoadingSpinner>
        </>
    } else {
        let property_desc = snapShotInfoData["property_desc"];
        if (property_desc.length > 50) {
            property_desc = property_desc.substring(0, 50) + "...";
        }
        let address = snapShotInfoData["address"];
        if (address.length > 50) {
            address = address.substring(0, 50) + "...";
        }
        let indicator = 2;
        // 0: -, 1:+, 2: do not show 3: do not show cause reported
        let currentRollNum = "";
        let parentRoll = "";
        if (props.snapRoll.length < 19) {
            currentRollNum = props.snapRoll + '0000';
        } else {
            currentRollNum = props.snapRoll
        }
        for (let i = 0; i < props.snapList.length; i++) {
            if (props.snapList[i]['type'] === 'MY_PROPERTY') {
                parentRoll = props.snapList[i]['roll'];
            }
            if (currentRollNum === props.snapList[i]['roll']) {
                if (props.snapList[i]['type'] === 'POI') {
                    if (props.snapList[i]['reported'] === 0) {
                        indicator = 0;
                    } else {
                        indicator = 3;
                    }
                } else if (props.snapList[i]['type'] === 'SNAPSHOT') {
                    if (snapShotInfoData["poi_addable"]) {
                        indicator = 1;
                    }
                }
            }
        }
        return <>
            <GetStreetView coords={props.coords} address={address} />
            <AmpLoadingSpinner loading={loading}>
                <table className="table table-sm popup-address" role="presentation">
                    <tbody>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.Address")}</b>
                            </td>
                            <td title={snapShotInfoData["address"]}>
                                {address}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.Property-Description")}</b>
                            </td>
                            <td title={snapShotInfoData["property_desc"]}>
                                {property_desc}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.Year-Built")}</b>
                            </td>
                            <td>
                                {snapShotInfoData["year_built"]}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.Building")}</b>
                            </td>
                            <td>
                                {snapShotInfoData["building_area"]}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.Lot-Size")}</b>
                            </td>
                            <td>
                                {snapShotInfoData["lot_area"]}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.Number-of-Storeys")}</b>
                            </td>
                            <td>
                                {snapShotInfoData["num_stories"]}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.CVA")}</b>
                            </td>
                            <td>
                                {snapShotInfoData["cva"]}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{t("nbhd.popup-card.Sales")}</b>
                            </td>
                            <td>
                                {snapShotInfoData["sales"]}
                            </td>
                        </tr>
                        {isAmppa && (<tr>
                            <td>
                                <b>{t("nbhd.popup-card.roll-num")}</b>
                            </td>
                            <td>
                                {snapShotInfoData["roll"]}
                            </td>
                        </tr>)}
                        
                    </tbody>
                    <PopUpHeart indicateNum={loading ? undefined: indicator} rollNum={props.snapRoll} parentRoll={parentRoll} address={address}/>
                </table>
            </AmpLoadingSpinner>
        </>
    }

}